import { formatIQD } from '../../../shared/format.js';

// الخادم يعيد { warehouses: [...], total, totalQuantity } — بلا مفتاح
// `items` كي لا يفكّه مُعترض api فتفقد شاشة المخزون `total`. إغفال
// `warehouses` هنا كان يُظهر «لا توجد بيانات» دائماً.
function normalize(data) {
  const arr = Array.isArray(data)
    ? data
    : data?.warehouses || data?.items || data?.data || [];
  return arr.map((r, i) => ({
    id: r.id ?? r._id ?? `iv-${i}`,
    warehouse: r.warehouse ?? r.warehouseName ?? r.name ?? '—',
    productCount: Number(r.productCount ?? r.products ?? r.count ?? 0),
    quantity: Number(r.quantity ?? r.totalQty ?? r.qty ?? 0),
    value: Number(r.value ?? r.totalValue ?? r.cost ?? 0)
  }));
}

export function InventoryValueTable({ data }) {
  const rows = normalize(data);
  const totalValue = rows.reduce((s, r) => s + r.value, 0);

  if (!rows.length) {
    return <div className="text-ink-3 text-center py-10 text-sm">لا توجد بيانات بعد</div>;
  }

  return (
    <table className="w-full text-[13px]">
      <thead className="text-ink-2 text-[12px]">
        <tr className="border-b border-line">
          <th className="p-2.5 text-start">المخزن</th>
          <th className="p-2.5 text-start">عدد المنتجات</th>
          <th className="p-2.5 text-start">الكمية الإجمالية</th>
          <th className="p-2.5 text-start">قيمة المخزون</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((r) => (
          <tr key={r.id} className="border-b border-line">
            <td className="p-2.5 font-bold">{r.warehouse}</td>
            <td className="p-2.5">{r.productCount}</td>
            <td className="p-2.5">{r.quantity}</td>
            <td className="p-2.5 font-bold" style={{ color: '#C2570D' }}>
              {formatIQD(r.value)}
            </td>
          </tr>
        ))}
        <tr className="bg-paper-2">
          <td className="p-2.5 font-bold">الإجمالي</td>
          <td className="p-2.5"></td>
          <td className="p-2.5"></td>
          <td className="p-2.5 font-bold" style={{ color: '#C2570D' }}>
            {formatIQD(totalValue)}
          </td>
        </tr>
      </tbody>
    </table>
  );
}
